import { Config } from './config.model';

export const config: Partial<Config> = {
  api: {
    url: 'https://maestro-webapi-tuzla-01.oplog.cloud',
    terminalWebSocketUrl: 'wss://terminal.ras.oplog.cloud:6161/',
  },
  auth: {
    domain: 'https://oplog.kinde.com',
    client_id: '3ae471e315584df88787c43a5379a3f8',
    redirect_uri: 'https://maestro-tuzla-01.oplog.app/callback',
    logout_uri: 'https://maestro-tuzla-01.oplog.app/login',
    audience: 'https://maestro-api',
    scope: 'openid email profile offline',
    org_code: 'org_1d15904993f', // Tuzla01 warehouse
  },
};
